<template>
  <div class="saddle-step-three">
    <h3 class="mb-2">
      Finition demandée :
    </h3>
    <v-layout
      justify-space-between
      wrap
    >
      <v-flex
        sm6
        pr-6
      >
        <h4 class="mb-2">
          EXTERIEUR :
        </h4>
        <v-layout justify-space-between>
          <v-layout class="color-select">
            <v-select
              v-model="form.transfer_id"
              :items="transferColors"
              item-text="label"
              item-value="id"
              label="Transfert :"
              filled
              clearable
            />
            <template v-if="previewTransfer">
              <v-flex
                v-if="previewTransfer.texture == 'TEXTURE'"
                class="preview"
                style="width: 35px; height: 35px"
              >
                <img
                  :src="previewTransfer.image"
                  style="width: 100%; height:100%"
                  alt
                >
              </v-flex>
              <v-flex
                v-else-if="previewTransfer.texture == 'COLOR'"
                class="preview"
                :style="{ 'background-color': previewTransfer.rgb_code }"
              />
            </template>
          </v-layout>
        </v-layout>
        <v-layout justify-space-between>
          <v-text-field
            v-model="form.other_exterior_finishes"
            label="Autre :"
            outlined
          />
        </v-layout>
      </v-flex>
      <v-flex sm6>
        <h4 class="mb-2">
          INTERIEUR :
        </h4>

        <v-layout class="checkbox-input-container ma-0">
          <v-flex sm5>
            <h6>Evazote :</h6>
          </v-flex>
          <v-text-field
            v-model="form.interior_evazote_measure"
            v-validate="'numeric|max:4'"
            data-vv-name="(Finition demandée) Evazote"
            :class="{ error: errors.has('(Finition demandée) Evazote') }"
            class="mb-2"
            label="mm :"
            type="number"
            outlined
          />
        </v-layout>

        <v-layout class="checkbox-input-container ma-0">
          <v-flex sm5>
            <h6>Plastazote :</h6>
          </v-flex>
          <v-text-field
            v-model="form.interior_plastazote_measure"
            v-validate="'numeric|max:4'"
            data-vv-name="(Finition demandée) Plastazote"
            :class="{ error: errors.has('(Finition demandée) Plastazote') }"
            class="mb-2"
            label="mm :"
            type="number"
            outlined
          />
        </v-layout>

        <v-layout class="checkbox-input-container ma-0">
          <v-flex sm5>
            <h6>Mousse :</h6>
          </v-flex>
          <v-text-field
            v-model="form.interior_mousse_measure"
            v-validate="'numeric|max:4'"
            data-vv-name="(Finition demandée) Mousse"
            :class="{ error: errors.has('(Finition demandée) Mousse') }"
            class="mb-2"
            label
            type="number"
            outlined
          />
        </v-layout>

        <v-layout class="checkbox-input-container ma-0">
          <v-flex sm5>
            <h6>Thermozaïque :</h6>
          </v-flex>
          <v-layout class="color-select">
            <v-select
              v-model="form.thermozaique_color_id"
              :items="thermoColors"
              item-text="label"
              item-value="id"
              label="Couleur"
              filled
              hide-details
              class="mb-2"
              clearable
            />
            <template v-if="previewThermoColor">
              <v-flex
                v-if="previewThermoColor.texture == 'TEXTURE'"
                class="preview"
                style="width: 35px; height: 35px"
              >
                <img
                  :src="previewThermoColor.image"
                  style="width: 100%; height:100%"
                  alt
                >
              </v-flex>
              <v-flex
                v-else-if="previewThermoColor"
                class="preview"
                :style="{ 'background-color': previewThermoColor.rgb_code }"
              />
            </template>
          </v-layout>
        </v-layout>

        <v-layout class="checkbox-input-container ma-0">
          <v-flex sm5>
            <h6>Autre :</h6>
          </v-flex>
          <v-text-field
            v-model="form.interior_other"
            label
            hide-details
            outlined
            maxlength="20"
          />
        </v-layout>
      </v-flex>
    </v-layout>

    <h3 class="mb-2">
      Protection du châssis :
    </h3>
    <v-layout
      justify-space-between
      wrap
    >
      <v-flex sm4>
        <v-layout justify-space-between>
          <v-text-field
            v-model="form.chassis_protection_bumper"
            maxlength="20"
            label="Butoir :"
            outlined
          />
        </v-layout>
        <v-layout justify-space-between>
          <v-text-field
            v-model="form.chassis_protection_finition"
            maxlength="20"
            label="Finition :"
            outlined
          />
        </v-layout>
      </v-flex>

      <v-flex
        sm6
        mb-5
      >
        <v-btn
          block
          @click="$emit('show-drawing')"
        >
          Croquis
        </v-btn>
        <v-layout class="ml-12 mt-3">
          <v-flex>
            <img
              src="@/assets/img/schema_selle_3.svg"
              alt
            >
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-simple-table class="mb-5">
      <thead>
        <tr>
          <th class="text-center">
            Finitions :
          </th>
          <th class="text-center">
            Position
          </th>
          <th class="text-center">
            Sangle
          </th>
          <th class="text-center">
            Sangle Élastique
          </th>
          <th class="text-center">
            Velcro
          </th>
          <th class="text-center">
            Taille Clip
          </th>
          <th class="text-center">
            Clip
          </th>
          <th class="text-center">
            Coussin
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>Sangle 1</th>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.strap1"
                :items="dropdowns.strap1"
                item-text="label"
                item-value="value"
                label
                filled
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-select
              v-model="form.strap1_strap"
              :items="dropdowns.strap1_strap"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.strap1_material_strap"
              :items="dropdowns.strap1_material_strap"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.strap1_velcro"
              :items="dropdowns.strap1_velcro"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.strap1_clip"
              :items="dropdowns.strap1_clip"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.strap1_clips"
              :items="dropdowns.strap1_clips"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.strap1_cushion"
              :items="dropdowns.strap1_cushion"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
        </tr>
        <tr>
          <th>Sangle 2</th>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.strap2"
                :items="dropdowns.strap2"
                item-text="label"
                item-value="value"
                label
                filled
                clearable
                hide-details
              />
            </v-layout>
          </td>
          <td>
            <v-select
              v-model="form.strap2_strap"
              :items="dropdowns.strap2_strap"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.strap2_material_strap"
              :items="dropdowns.strap2_material_strap"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.strap2_velcro"
              :items="dropdowns.strap2_velcro"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.strap2_clip"
              :items="dropdowns.strap2_clip"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.strap2_clips"
              :items="dropdowns.strap2_clips"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.strap2_cushion"
              :items="dropdowns.strap2_cushion"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-textarea
      v-model="form.sewing_comments"
      filled
      name="Commentaires couture :"
      label="Commentaires couture :"
      value
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SeatStepThree",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      transferColors: "colors/getTRANSFERType",
      thermoColors: "colors/getTHERMOType",
      dropdowns: "dropdowns/getSeatOptions"
    }),

    // Returns transfer textures
    previewTransfer() {
      return this.transferColors.find(item => item.id == this.form.transfer_id);
    },

    previewThermoColor() {
      return this.thermoColors.find(
        color => color.id == this.form.thermozaique_color_id
      );
    }
  },
  created() {
    this.$validator = this.parentValidator;
  }
};
</script>

<style lang="scss">
.saddle-step-three {
  .v-input--selection-controls {
    &.v-input {
      .v-input__control {
        flex-grow: 1;
      }
      .v-label {
        width: 100%;
      }
    }
    .v-input__slot {
      align-items: flex-start;
      .v-label {
        align-items: baseline;
      }
    }
  }
  .canvas-container {
    width: 100%;
    height: 600px;
    max-height: 150px;
    display: flex;
    .canvas-item {
      height: 100%;
      width: 100%;
      background-color: purple;
    }
  }
  .v-btn {
    background-color: #006064 !important;
    color: white !important;
  }
}
</style>
